module.exports = __webpack_public_path__ + "static/media/yellow-passionfruit.6c1a5907.png";